import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { useHttpClient } from '@bonusly/http-client';

import { RecognizeResponse } from '../../../../types/api';
import { HashtagTrend } from '../../../../types/hashtag';
import { ResourcePath } from './ResourcePath';
import { QueryKey, QueryOptions } from './types';

type Format = 'index' | 'summary';

interface SummaryResponse {
	trends: {
		custom: HashtagTrend[];
		values: HashtagTrend[];
	};
}

type ListResponse = string[];
type ResponseType<T> = T extends 'summary' ? SummaryResponse : ListResponse;
type IndexResponse<T = Format> = RecognizeResponse<ResponseType<T>>;

interface IndexArgs<T extends Format = Format> {
	params: {
		display_format?: T;
	};
}

export type HashtagIndexResponse<T = Format> = AxiosResponse<IndexResponse<T>>;

export const useHashtags = <T extends Format = Format>(args: IndexArgs<T>, options?: QueryOptions<HashtagIndexResponse<T>>) => {
	const http = useHttpClient('v2');

	return useQuery<HashtagIndexResponse<T>>(
		[QueryKey.Hashtags, args],
		() =>
			http.get<IndexResponse<T>>(ResourcePath.Hashtags, {
				params: args.params,
			}),
		options
	);
};
